import { render, staticRenderFns } from "./UsageHistoryAndPointDetail.vue?vue&type=template&id=31656894&"
import script from "./UsageHistoryAndPointDetail.vue?vue&type=script&lang=ts&"
export * from "./UsageHistoryAndPointDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports